// Lecture tolérante du texte des horaires saisi dans l'adminpanel
// (ex : "/*mercredi*/, /*vendredi*/ 10h - 13h30 | 15h-19h<br/>/*jeudi*/ 15h-19h | /*samedi*/ 10h-15h")
// pour en déduire un planning par jour et le statut "Ouvert / Fermé" du moment.

const DAY_INDEX = { dimanche: 0, lundi: 1, mardi: 2, mercredi: 3, jeudi: 4, vendredi: 5, samedi: 6 };
export const DAY_NAMES = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
export const DAY_LABELS = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
export const WEEK_ORDER = [1, 2, 3, 4, 5, 6, 0];

export function formatHour(h) {
    const hh = Math.floor(h);
    const mm = Math.round((h - hh) * 60);
    return hh + 'h' + (mm ? String(mm).padStart(2, '0') : '');
}

// Retourne { [jour 0-6]: [[debut, fin], ...] } (heures décimales) ou null si rien n'est lisible.
export function parseHoraires(text) {
    if (!text) return null;
    const clean = text
        .replace(/<br\s*\/?>/gi, '|')
        .replace(/\n/g, '|')
        .replace(/\/\*|\*\/|\/\//g, ' ');
    const tokens = clean.split(/[|,]/).map((t) => t.trim()).filter(Boolean);
    const schedule = {};
    let days = [];
    let gotHours = false;

    tokens.forEach((tok) => {
        const lower = tok.toLowerCase();
        const found = Object.keys(DAY_INDEX).filter((d) => lower.includes(d)).map((d) => DAY_INDEX[d]);
        if (found.length) {
            if (gotHours) { days = []; gotHours = false; }
            found.forEach((d) => { if (!days.includes(d)) days.push(d); });
        }
        const rangeRe = /(\d{1,2})\s*h\s*(\d{2})?\s*-\s*(\d{1,2})\s*h\s*(\d{2})?/gi;
        const ranges = [];
        let m;
        while ((m = rangeRe.exec(tok))) {
            ranges.push([Number(m[1]) + (Number(m[2]) || 0) / 60, Number(m[3]) + (Number(m[4]) || 0) / 60]);
        }
        if (ranges.length && days.length) {
            days.forEach((d) => { schedule[d] = (schedule[d] || []).concat(ranges); });
            gotHours = true;
        }
    });

    return Object.keys(schedule).length ? schedule : null;
}

// Statut du moment : { open, text, sub } ou null si pas de planning.
export function getStatus(schedule, now = new Date()) {
    if (!schedule) return null;
    const d = now.getDay();
    const t = now.getHours() + now.getMinutes() / 60;
    const today = schedule[d] || [];
    for (let i = 0; i < today.length; i++) {
        const [a, b] = today[i];
        if (t >= a && t < b) return { open: true, text: 'Ouvert', sub: 'ferme à ' + formatHour(b) };
        if (t < a) return { open: false, text: 'Fermé', sub: 'ouvre à ' + formatHour(a) };
    }
    for (let k = 1; k <= 7; k++) {
        const nd = (d + k) % 7;
        if (schedule[nd] && schedule[nd].length) {
            const when = k === 1 ? 'demain' : DAY_NAMES[nd];
            return { open: false, text: 'Fermé', sub: 'ouvre ' + when + ' à ' + formatHour(schedule[nd][0][0]) };
        }
    }
    return { open: false, text: 'Fermé', sub: '' };
}
